import { current } from '@reduxjs/toolkit';
import { set } from 'core-js/core/dict';
import { style } from 'd3-selection';
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import {
	RtxPrecisionInput,
	RtxPrecisionInputProps
} from 'RtUi/components/rtx/inputs/Precision/RtxPrecisionInput';
import { RtxTextInput } from 'RtUi/components/rtx/inputs/Text/RtxTextInput';
type RtxRateMultipliersInputProps = Omit<RtxPrecisionInputProps, ''> & {
	onChange?: (value: number | null) => void;
	displayMode?: boolean;
	currentValues?: number[][];
};
export const RtxRateMultipliersInput = ({
	disabled,
	className,
	value,
	onChange = () => {},
	displayMode,
	currentValues,
	...props
}: RtxRateMultipliersInputProps) => {
	const useClassName = className || 'mb-3 inline-form';

	const carrierCountWidth = 2; // Number of columns for each carrier input
	const percentageLabel = '';
	const percentageWidth = 1; // Width for the percentage input

	const [oneOne, setOneOne] = useState<number>(
		currentValues?.[0]?.[0] ? currentValues?.[0]?.[0] * 100 : 0
	);

	const [twoOne, setTwoOne] = useState<number>(
		currentValues?.[1]?.[0] ? currentValues?.[1]?.[0] * 100 : 0
	);
	const [twoTwo, setTwoTwo] = useState<number>(
		currentValues?.[1]?.[0] ? currentValues?.[1]?.[1] * 100 : 0
	);

	const [threeOne, setThreeOne] = useState<number>(
		currentValues?.[2]?.[0] ? currentValues?.[2]?.[0] * 100 : 0
	);
	const [threeTwo, setThreeTwo] = useState<number>(
		currentValues?.[2]?.[1] ? currentValues?.[2]?.[1] * 100 : 0
	);
	const [threeThree, setThreeThree] = useState<number>(
		currentValues?.[2]?.[2] ? currentValues?.[2]?.[2] * 100 : 0
	);

	const [fourOne, setFourOne] = useState<number>(
		currentValues?.[3]?.[0] ? currentValues?.[3]?.[0] * 100 : 0
	);
	const [fourTwo, setFourTwo] = useState<number>(
		currentValues?.[3]?.[1] ? currentValues?.[3]?.[1] * 100 : 0
	);
	const [fourThree, setFourThree] = useState<number>(
		currentValues?.[3]?.[2] ? currentValues?.[3]?.[2] * 100 : 0
	);
	const [fourFour, setFourFour] = useState<number>(
		currentValues?.[3]?.[3] ? currentValues?.[3]?.[3] * 100 : 0
	);

	const [fiveOne, setFiveOne] = useState<number>(
		currentValues?.[4]?.[0] ? currentValues?.[4]?.[0] * 100 : 0
	);
	const [fiveTwo, setFiveTwo] = useState<number>(
		currentValues?.[4]?.[1] ? currentValues?.[4]?.[1] * 100 : 0
	);
	const [fiveThree, setFiveThree] = useState<number>(
		currentValues?.[4]?.[2] ? currentValues?.[4]?.[2] * 100 : 0
	);
	const [fiveFour, setFiveFour] = useState<number>(
		currentValues?.[4]?.[3] ? currentValues?.[4]?.[3] * 100 : 0
	);
	const [fiveFive, setFiveFive] = useState<number>(
		currentValues?.[4]?.[4] ? currentValues?.[4]?.[4] * 100 : 0
	);

	const [oneTotal, setOneTotal] = useState<number>(oneOne);
	const [twoTotal, setTwoTotal] = useState<number>(twoOne + twoTwo);
	const [threeTotal, setThreeTotal] = useState<number>(
		threeOne + threeTwo + threeThree
	);
	const [fourTotal, setFourTotal] = useState<number>(
		fourOne + fourTwo + fourThree + fourFour
	);
	const [fiveTotal, setFiveTotal] = useState<number>(
		fiveOne + fiveTwo + fiveThree + fiveFour + fiveFive
	);

	const updateTotals = () => {
		setOneTotal(oneOne);
		setTwoTotal(twoOne + twoTwo);
		setThreeTotal(threeOne + threeTwo + threeThree);
		setFourTotal(fourOne + fourTwo + fourThree + fourFour);
		setFiveTotal(fiveOne + fiveTwo + fiveThree + fiveFour + fiveFive);
	};

	return (
		<>
			<Row>
				<Col md={2}>
					# Vendors
					<br />
					<br />
				</Col>
				<Col md={5}>Percentages</Col>
				<Col md={3}>Total Percentage</Col>
			</Row>
			<Row>
				<Col md={carrierCountWidth}>1</Col>
				<Col md={1}>
					<RtxPrecisionInput
						precision={0}
						label={percentageLabel}
						disabled={disabled}
						className={useClassName}
						displayMode={displayMode}
						onChange={(value) => {
							setOneOne(Number(value));
							updateTotals();
						}}
						value={oneTotal}
					/>
				</Col>
				<Col md={4}></Col>
				<Col md={1}>
					<RtxTextInput
						label={''}
						disabled={true}
						className={useClassName}
						displayMode={displayMode}
						required={props.required}
						value={oneTotal}
					/>
				</Col>
			</Row>
			<Row>
				<Col md={carrierCountWidth}>2</Col>
				<Col md={1}>
					<RtxPrecisionInput
						precision={0}
						label={percentageLabel}
						disabled={disabled}
						className={useClassName}
						displayMode={displayMode}
						onChange={(value) => {
							setTwoOne(Number(value));
							updateTotals();
						}}
						value={twoOne}
					/>
				</Col>
				<Col md={1}>
					<RtxPrecisionInput
						precision={0}
						label={percentageLabel}
						disabled={disabled}
						className={useClassName}
						displayMode={displayMode}
						onChange={(value) => {
							setTwoTwo(Number(value));
							updateTotals();
						}}
						value={twoTwo}
					/>
				</Col>
				<Col md={3}></Col>
				<Col md={1}>
					<RtxTextInput
						label={''}
						disabled={true}
						className={useClassName}
						displayMode={displayMode}
						required={props.required}
						value={twoTotal}
					/>
				</Col>
			</Row>
			<Row>
				<Col md={carrierCountWidth}>3</Col>
				<Col md={percentageWidth}>
					<RtxPrecisionInput
						precision={0}
						label={percentageLabel}
						disabled={disabled}
						className={useClassName}
						displayMode={displayMode}
						onChange={(value) => {
							setThreeOne(Number(value));
							updateTotals();
						}}
						value={threeOne}
					/>
				</Col>
				<Col md={percentageWidth}>
					<RtxPrecisionInput
						precision={0}
						label={percentageLabel}
						disabled={disabled}
						className={useClassName}
						displayMode={displayMode}
						onChange={(value) => {
							setThreeTwo(Number(value));
							updateTotals();
						}}
						value={threeTwo}
					/>
				</Col>
				<Col md={percentageWidth}>
					<RtxPrecisionInput
						precision={0}
						label={percentageLabel}
						disabled={disabled}
						className={useClassName}
						displayMode={displayMode}
						onChange={(value) => {
							setThreeThree(Number(value));
						}}
						value={threeThree}
					/>
				</Col>
				<Col md={2}></Col>
				<Col md={1}>
					<RtxTextInput
						label={''}
						disabled={true}
						className={useClassName}
						displayMode={displayMode}
						required={props.required}
						value={threeTotal}
					/>
				</Col>
			</Row>
			<Row>
				<Col md={carrierCountWidth}>4</Col>
				<Col md={percentageWidth}>
					<RtxPrecisionInput
						precision={0}
						label={percentageLabel}
						disabled={disabled}
						className={useClassName}
						displayMode={displayMode}
						onChange={(value) => {
							setFourOne(Number(value));
							updateTotals();
						}}
						value={fourOne}
					/>
				</Col>
				<Col md={percentageWidth}>
					<RtxPrecisionInput
						precision={0}
						label={percentageLabel}
						disabled={disabled}
						className={useClassName}
						displayMode={displayMode}
						onChange={(value) => {
							setFourTwo(Number(value));
							updateTotals();
						}}
						value={fourTwo}
					/>
				</Col>
				<Col md={percentageWidth}>
					<RtxPrecisionInput
						precision={0}
						label={percentageLabel}
						disabled={disabled}
						className={useClassName}
						displayMode={displayMode}
						onChange={(value) => {
							setFourThree(Number(value));
							updateTotals();
						}}
						value={fourThree}
					/>
				</Col>
				<Col md={percentageWidth}>
					<RtxPrecisionInput
						precision={0}
						label={percentageLabel}
						disabled={disabled}
						className={useClassName}
						displayMode={displayMode}
						onChange={(value) => {
							setFourFour(Number(value));
							updateTotals();
						}}
						value={fourFour}
					/>
				</Col>
				<Col md={1}></Col>
				<Col md={1}>
					<RtxTextInput
						label={''}
						disabled={true}
						className={useClassName}
						displayMode={displayMode}
						required={props.required}
						value={fourTotal}
					/>
				</Col>
			</Row>
			<Row>
				<Col md={carrierCountWidth}>5</Col>
				<Col md={percentageWidth}>
					<RtxPrecisionInput
						precision={0}
						label={percentageLabel}
						disabled={disabled}
						className={useClassName}
						displayMode={displayMode}
						onChange={(value) => {
							setFiveOne(Number(value));
							updateTotals();
						}}
						value={fiveOne}
					/>
				</Col>
				<Col md={percentageWidth}>
					<RtxPrecisionInput
						precision={0}
						label={percentageLabel}
						disabled={disabled}
						className={useClassName}
						displayMode={displayMode}
						onChange={(value) => {
							setFiveTwo(Number(value));
							updateTotals();
						}}
						value={fiveTwo}
					/>
				</Col>
				<Col md={percentageWidth}>
					<RtxPrecisionInput
						precision={0}
						label={percentageLabel}
						disabled={disabled}
						className={useClassName}
						displayMode={displayMode}
						onChange={(value) => {
							setFiveThree(Number(value));
							updateTotals();
						}}
						value={fiveThree}
					/>
				</Col>
				<Col md={percentageWidth}>
					<RtxPrecisionInput
						precision={0}
						label={percentageLabel}
						disabled={disabled}
						className={useClassName}
						displayMode={displayMode}
						onChange={(value) => {
							setFiveFour(Number(value));
							updateTotals();
						}}
						value={fiveFour}
					/>
				</Col>
				<Col md={percentageWidth}>
					<RtxPrecisionInput
						precision={0}
						label={percentageLabel}
						disabled={disabled}
						className={useClassName}
						displayMode={displayMode}
						onChange={(value) => {
							setFiveFive(Number(value));
							updateTotals();
						}}
						value={fiveFive}
					/>
				</Col>
				<Col md={1}>
					<RtxTextInput
						label={''}
						disabled={true}
						className={useClassName}
						displayMode={displayMode}
						required={props.required}
						value={fiveTotal}
					/>
				</Col>
			</Row>

			{/* <RtxPrecisionInput
				precision={0}
				label={label}
				disabled={disabled}
				className={useClassName}
				displayMode={displayMode}
				required={props.required}
				onChange={onChange}
				value={value} /> */}
		</>
	);
};
